// Zustand app store (= DDSIM-11)。 1 store / 単純な flat state。
// DDSIM-18 で decks/setDecks を撤去 (= サンプルデッキへ移行)。

import { create } from "zustand";

export type WsState = "idle" | "connecting" | "connected" | "closed";

export interface AppState {
  serverBaseUrl: string;
  wsState: WsState;
  lastError: string | null;
}

export interface AppActions {
  setBaseUrl: (url: string) => void;
  setWsState: (s: WsState) => void;
  setError: (e: string | null) => void;
}

export type AppStore = AppState & AppActions;

const INITIAL_STATE: AppState = {
  serverBaseUrl: "http://localhost:7878",
  wsState: "idle",
  lastError: null,
};

export const useAppStore = create<AppStore>()((set) => ({
  ...INITIAL_STATE,
  setBaseUrl: (url) => set({ serverBaseUrl: url }),
  setWsState: (s) => set({ wsState: s }),
  setError: (e) => set({ lastError: e }),
}));
